import { render, staticRenderFns } from "./MaiaInstructions.vue?vue&type=template&id=299d2c70&scoped=true"
import script from "@/views/Settings/MaiaInstructions/MaiaInstructions.ts?vue&type=script&lang=ts&external"
export * from "@/views/Settings/MaiaInstructions/MaiaInstructions.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Settings/MaiaInstructions/maia-instructions.scss?vue&type=style&index=0&id=299d2c70&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299d2c70",
  null
  
)

export default component.exports